import { Component } from 'preact';

// Hand-drawn 17x13 pixel-art fox head. Each row is a string; each
// character is one pixel. The grid is designed to read as a
// forward-facing fox at logo scale. Two pointed ears, a rounded
// brow, twin eye columns, and a white muzzle with a black nose.
//
//  transparent
//   1  outline       (#1a1210)
//   2  fur primary   (#e87a3c)
//   3  fur highlight (#f4a062)
//   4  muzzle cream  (#f5ead0)
//   5  eye           (#0a0505)
const FOX_ROWS = [
  '..111.......111..',
  '.12321.....12321.',
  '.123321...123321.',
  '12333321112333321',
  '12333333333333321',
  '12335333333533321',
  '12335333333533321',
  '.123333444333321.',
  '..1233441443321..',
  '...12344444321...',
  '....123444321....',
  '.....1222221.....',
  '......11111......',
];

const PALETTE = {
  '1': '#1a1210',
  '2': '#e87a3c',
  '3': '#f4a062',
  '4': '#f5ead0',
  '5': '#0a0505',
};

const FOX_WIDTH = 17;
const FOX_HEIGHT = FOX_ROWS.length;

function renderFoxRects() {
  const rects = [];
  for (let y = 0; y < FOX_HEIGHT; y++) {
    const row = FOX_ROWS[y];
    for (let x = 0; x < FOX_WIDTH; x++) {
      const fill = PALETTE[row[x]];
      if (!fill) continue;
      rects.push(<rect key={`${x}-${y}`} x={x} y={y} width={1} height={1} fill={fill} />);
    }
  }
  return rects;
}

/**
 * Studio mark used in the cold-boot intro splash. SVG keeps the pixel
 * grid crisp at any scale without the integer-multiple constraint that
 * `image-rendering: pixelated` imposes on raster assets.
 */
export default class ClutterfoxLogo extends Component {
  render() {
    const { scale = 10, glow = true } = this.props;
    const w = FOX_WIDTH * scale;
    const h = FOX_HEIGHT * scale;

    return (
      <div className="clutterfox-logo">
        <svg
          className="clutterfox-logo__mark"
          width={w}
          height={h}
          viewBox={`0 0 ${FOX_WIDTH} ${FOX_HEIGHT}`}
          shape-rendering="crispEdges"
          aria-hidden="true"
        >
          {glow ? (
            <defs>
              <filter id="cf-glow" x="-25%" y="-25%" width="150%" height="150%">
                <feGaussianBlur in="SourceGraphic" stdDeviation="0.35" result="blur" />
                <feMerge>
                  <feMergeNode in="blur" />
                  <feMergeNode in="SourceGraphic" />
                </feMerge>
              </filter>
            </defs>
          ) : null}
          <g filter={glow ? 'url(#cf-glow)' : undefined}>{renderFoxRects()}</g>
        </svg>
        <div className="clutterfox-logo__wordmark">
          <div className="clutterfox-logo__name">CLUTTERFOX</div>
          <div className="clutterfox-logo__suffix">
            <span className="clutterfox-logo__flourish" aria-hidden="true">◆</span>
            <span>STUDIOS</span>
            <span className="clutterfox-logo__flourish" aria-hidden="true">◆</span>
          </div>
        </div>
      </div>
    );
  }
}
